import { DataFieldType } from './DataFieldType';
export var TelemetryEventValidator;
(function (TelemetryEventValidator) {
    var INT64_MIN = -9007199254740991;
    var INT64_MAX = 9007199254740991;
    // Starts with A-Z, and then contains only alphanumerics
    var StartsWithCapitalRegex = /^[A-Z][a-zA-Z0-9]*$/;
    // Contains alphanumeric or _ or .
    var AlphanumericRegex = /^[a-zA-Z0-9_\.]*$/;
    function validateTelemetryEvent(event) {
        if (!isEventNameValid(event.eventName)) {
            throw new Error('Invalid eventName');
        }
        if (event.eventContract && !isEventContractValid(event.eventContract)) {
            throw new Error('Invalid eventContract');
        }
        if (event.dataFields != null) {
            for (var i = 0; i < event.dataFields.length; i++) {
                validateDataField(event.dataFields[i]);
            }
        }
    }
    TelemetryEventValidator.validateTelemetryEvent = validateTelemetryEvent;
    function isNamespaceValid(eventNamePieces) {
        // Min 3 pieces: Office.(Namespace).EventName)
        return !!eventNamePieces && eventNamePieces.length >= 3 && eventNamePieces[0] === 'Office';
    }
    function isEventNodeValid(eventNode) {
        return eventNode !== undefined && StartsWithCapitalRegex.test(eventNode);
    }
    function isEventNameValid(eventName) {
        var maxEventNameLength = 98; // Client Code = 100 limit; Aria Compact SDK = 98 limit.
        if (!eventName || eventName.length > maxEventNameLength) {
            return false;
        }
        var eventNamePieces = eventName.split('.');
        var eventNodeName = eventNamePieces[eventNamePieces.length - 1];
        return isNamespaceValid(eventNamePieces) && isEventNodeValid(eventNodeName);
    }
    function isEventContractValid(eventContract) {
        return isNameValid(eventContract.name);
    }
    function isDataFieldNameValid(dataFieldName) {
        var maxDataFieldNameLength = 100;
        var dataFieldPrefixLength = 5;
        return !!dataFieldName && isNameValid(dataFieldName) && dataFieldName.length + dataFieldPrefixLength < maxDataFieldNameLength;
    }
    function isNameValid(name) {
        return name !== undefined && AlphanumericRegex.test(name);
    }
    function validateDataField(dataField) {
        if (!isDataFieldNameValid(dataField.name)) {
            throw new Error('Invalid dataField name');
        }
        if (dataField.dataType === DataFieldType.Int64) {
            validateInt(dataField.value);
        }
    }
    function validateInt(value) {
        if (typeof value !== 'number' || !isFinite(value) || Math.floor(value) !== value || value < INT64_MIN || value > INT64_MAX) {
            throw new Error("Invalid integer " + JSON.stringify(value));
        }
    }
    TelemetryEventValidator.validateInt = validateInt;
})(TelemetryEventValidator || (TelemetryEventValidator = {}));
//# sourceMappingURL=TelemetryEventValidator.js.map